/**
 * <ia-press-quote-slider>
 * Static 2-column section. The card on the left holds an eyebrow (static),
 * a Swiper of quote+logo slides, and prev/next nav (static). The image on
 * the right is rendered by Liquid and never rotates.
 */
class IaPressQuoteSlider extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    const swiperEl = this.querySelector('.ia-press-quote-slider__swiper');
    if (!swiperEl || typeof Swiper === 'undefined') {
      return;
    }

    const navPrev = this.querySelector('.ia-press-quote-slider__btn--prev');
    const navNext = this.querySelector('.ia-press-quote-slider__btn--next');

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      a11y: {
        prevSlideMessage: 'Previous press quote',
        nextSlideMessage: 'Next press quote',
      },
      navigation: {
        prevEl: navPrev,
        nextEl: navNext,
        disabledClass: 'swiper-button-disabled',
      },
    });
  }

  disconnectedCallback() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this._initialized = false;
  }
}

if (!customElements.get('ia-press-quote-slider')) {
  customElements.define('ia-press-quote-slider', IaPressQuoteSlider);
}
